// extracted by mini-css-extract-plugin
export default {"attendanceStatus":"ReportTableView_attendanceStatus__fLjIp","userName":"ReportTableView_userName__GxOW3"};